var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.704,
    height: 12.704,
    viewBox: "0 0 12.704 12.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M0,0H12.7V12.7H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M6.37,7.066A5.588,5.588,0,0,0,8.462,9.158L8.929,8.5a.529.529,0,0,1,.685-.157,6.046,6.046,0,0,0,2.426.722.529.529,0,0,1,.488.528v2.362a.529.529,0,0,1-.475.527A8.209,8.209,0,0,1,3.043,3.475.529.529,0,0,1,3.57,3H5.932a.529.529,0,0,1,.528.488,6.046,6.046,0,0,0,.722,2.426.529.529,0,0,1-.157.685ZM5.035,6.718,6.04,6A7.1,7.1,0,0,1,5.46,4.059h-1.4c0,.088,0,.176,0,.265A7.145,7.145,0,0,0,11.2,11.469c.088,0,.177,0,.265-.005v-1.4a7.1,7.1,0,0,1-1.942-.581l-.718,1.006a6.586,6.586,0,0,1-.841-.4l-.031-.017A6.646,6.646,0,0,1,5.449,7.59l-.017-.031a6.586,6.586,0,0,1-.4-.841Z",
    transform: "translate(-1.412 -1.412)",
    fill: "gray"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1eb066bcc0e1188e218ddee5cb41e594.svg";
export { ForwardRef as ReactComponent };